import { stringToBoolean } from "@repo/shared-utils/pwa-utils";

/**
 * Normalizes a boolean value from AEM or other sources.
 * Handles string "true"/"false", boolean values, and undefined.
 *
 * @param value - The value to normalize (can be boolean, string "true"/"false", or undefined)
 * @param defaultValue - The default value to return if value is undefined
 * @returns Normalized boolean value
 *
 * @example
 * normalizeBoolean("true", false) // returns true
 * normalizeBoolean("false", true) // returns false
 * normalizeBoolean(undefined, true) // returns true
 * normalizeBoolean(true, false) // returns true
 */
export const normalizeBoolean = (
  value: boolean | string | undefined,
  defaultValue: boolean,
): boolean => {
  if (value === undefined) {
    return defaultValue;
  }
  if (typeof value === "string") {
    return stringToBoolean(value);
  }
  return value;
};

